export class Auth {
	public user: string;
	public pass: string;

	constructor(user: string, pass: string) {
		this.user = user;
		this.pass = pass;
	}
}
